<script setup>
import AppContract from "@/components/Admin/Tabs/AppContract";
//import AppPayments from "@/components/Admin/Tabs/AppPayments";
import {ref, computed, onMounted} from 'vue'
import {useStore} from "vuex";
import {useContractInfo} from "@/use/contract-info";

//----------------------------------------------------------------------
const store = useStore()
const loading = ref(false)

onMounted( ()=>{
  store.commit('menuModule/initMenu')
  const ifDataExist = !!contract.value
  // если данные есть в сторе, грузить не будем
  init(ifDataExist)
})

const init = async (ifDataExist) => {
  // если данные есть в сторе, грузить не будем
  if (!ifDataExist) {
    await useContractInfo(token.value, user.value.type, user.value.id)
  }
  loading.value = true
}

/*
// пока это не трогаем
const setNewMessageStatus = async (token, type, id) => {
  const newMessagesStatus = ref([])
  const url = process.env.VUE_APP_API + "new-messages.php"
  await axios
      .get(`${url}?token=${token}&section=${type}&id=${id}`)
      .then(response => (newMessagesStatus.value = response.data))
      .catch(error => alert(error));
  // 2 - сообщение от ЦДЖ
  // 3 - сообщение от ЦДЖ прочитано

  store.commit('menuModule/newMessage', newMessagesStatus.value.Status)
}

*/


//----------------------------------------------------------------------
const token = computed( () => {return store.getters['authModule/token']})
const user = computed( () => {return store.getters['authModule/user']})
const contract = computed( () => {return store.getters['contractModule/contract']})
</script>

<template>
    <section class="content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col d-flex justify-content-between">
            <h3>Мой договор</h3>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div v-if="loading" class="row">

          <div class="col-12" v-if="+user['type'] === 1">
            <div class="card card-outline card-danger">
              <div class="card-body">
                <h5>Уведомляем об изменении своего наименования на АО МКК «СПб ЦДЖ».</h5>
                <p>Реквизиты для оплаты остаются прежними, изменяется наименование получателя платежа: <b>АО МКК «СПб ЦДЖ»</b>.</p>
                - <a href="https://gorcenter.spb.ru/press/status-mikrokreditnoj-kompanii" target="_blank">
                Что такое статус микрокредитной компании</a>
                <br>- <a href="https://gorcenter.spb.ru/pogasheniye-ipotechnogo-kredita/spbcdj" target="_blank">Погашение ипотечного кредита</a>
              </div>
            </div>
          </div>

          <div class="col-12" v-if="+user['type'] === 2">
            <div class="card card-outline card-danger">
              <div class="card-body">
                <h5>Уведомляем об изменении своего наименования на АО МКК «СПб ЦДЖ».</h5>
                <p>Реквизиты для оплаты остаются прежними, изменяется наименование получателя платежа: <b>АО МКК «СПб ЦДЖ»</b>.</p>
                - <a href="https://gorcenter.spb.ru/press/status-mikrokreditnoj-kompanii" target="_blank">
                Что такое статус микрокредитной компании</a>
                <br>- <a href="https://gorcenter.spb.ru/pogasheniye-zhilishchnogo-zayma" target="_blank">Погашение целевого жилищного займа</a>
                <br>- <a href="https://gorcenter.spb.ru/pogasheniye-rassrochki-operatoru" target="_blank">Погашение рассрочки оператору</a>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div v-if="contract[0].delay == 0" class="alert-success p-2 mb-4 rounded d-flex align-items-center">
              <v-icon
                  icon="mdi:check-circle-outline"
                  class="icon--light-big mr-3"
              ></v-icon>
              <h5 class="pt-2">У Вас нет просроченных платежей</h5>
            </div>
            <div v-else class="alert-danger p-2 mb-4 rounded d-flex align-items-center">
              <v-icon
                  icon="mdi:bell-plus-outline"
                  class="icon--light-big mr-3"
              ></v-icon>
              <div>У Вас имеется просроченный платеж</div>
            </div>
            <app-contract></app-contract>
          </div>
        </div>
        <div v-else class="d-flex justify-content-center">
          <div class="spinner-border text-primary m-4" role="status"></div>
        </div>
      </div>
    </section>
</template>
<style scoped>
.alert-success{
  background-color: #80b5d3 !important;
}
</style>